import React, { useState, useEffect } from "react";
import { Typography, CircularProgress } from "@material-ui/core";
import { compose } from "recompose";
import {
    withAuthorization,
    AuthUserContext,
    withEmailVerification,
} from "../../Session";
import MaterialTable from "material-table";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import { withFirebase } from "../../components/Firebase";
import { tableIcons } from "../../components/TableIcons/TableIcons";
import useStyles from "./styles";
import sendEmail from '../../mail/sendEmail';

const ADMIN = "ADMIN";
const WS = "WS";
const APPROVED = 1;
const DISAPPROVED = 2;

const Reservation = () => {
    var classes = useStyles();

    return (
        <React.Fragment>
            <Typography variant="h3" className={classes.title}>
                Reservasjon
            </Typography>
            <Reservations />
        </React.Fragment>
    );
};

function ReservationBase(props) {
    var classes = useStyles();

    var [isLoading, setIsLoading] = useState(false);
    var [surfaces, setSurfaces] = useState([]);
    var [reserves, setReserves] = useState([]);
    var [error, setError] = useState(null);
    var [locations, setLocations] = useState([]);
    var [profiles, setProfiles] = useState([]);
    var [users, setUsers] = useState([]);
    var [items, setItems] = useState([]);

    useEffect(() => {
        onListenForReserves();
        onListenForProfiles();
        onListenForLocations();
        onListenForSurfaces();
        onListenForUsers();
        onListenForItems();

    }, []);

    const onListenForItems = () => {
        props.firebase
            .items()
            .orderByChild("createdAt")
            .on("value", snapshot => {
                const itemObject = snapshot.val();
                if (itemObject) {
                    const itemList = Object.keys(itemObject).map(key => ({
                        ...itemObject[key],
                        uid: key,
                    }));

                    setIsLoading(false);
                    setItems(itemList);
                } else {
                    setIsLoading(false);
                    setItems(items);
                }
            });
    };

    const onListenForProfiles = () => {
        setIsLoading(true);

        props.firebase
            .profiles()
            .orderByChild("createdAt")
            .on("value", snapshot => {
                const profileObject = snapshot.val();
                if (profileObject) {
                    const profileList = Object.keys(profileObject).map(key => ({
                        ...profileObject[key],
                        uid: key,
                    }));

                    setIsLoading(false);
                    setProfiles(profileList);
                } else {
                    setIsLoading(false);
                    setProfiles(profiles);
                }
            });
    };

    const onListenForLocations = () => {
        setIsLoading(true);

        props.firebase
            .locations()
            .orderByChild("createdAt")
            .on("value", snapshot => {
                const locationObject = snapshot.val();
                if (locationObject) {
                    const locationList = Object.keys(locationObject).map(
                        key => ({
                            ...locationObject[key],
                            uid: key,
                        }),
                    );

                    setIsLoading(false);
                    setLocations(locationList);
                } else {
                    setIsLoading(false);
                    setLocations(locations);
                }
            });
    };

    const onListenForSurfaces = () => {
        setIsLoading(true);

        props.firebase
            .surfaces()
            .orderByChild("createdAt")
            .on("value", snapshot => {
                const surfaceObject = snapshot.val();
                if (surfaceObject) {
                    const surfaceList = Object.keys(surfaceObject).map(key => ({
                        ...surfaceObject[key],
                        uid: key,
                    }));

                    setIsLoading(false);
                    setSurfaces(surfaceList);
                } else {
                    setIsLoading(false);
                    setSurfaces(surfaces);
                }
            });
    };

    const onListenForUsers = () => {
        setIsLoading(true);

        props.firebase
            .users()
            .orderByChild("createdAt")
            .on("value", snapshot => {
                const userObject = snapshot.val();
                if (userObject) {
                    const userList = Object.keys(userObject).map(key => ({
                        ...userObject[key],
                        uid: key,
                    }));

                    setIsLoading(false);
                    setUsers(userList);
                } else {
                    setIsLoading(false);
                    setUsers(users);
                }
            });
    };

    const onListenForReserves = () => {
        setIsLoading(true);

        props.firebase
            .reserves()
            .orderByChild("createdAt")
            .on("value", snapshot => {
                const surfaceObject = snapshot.val();
                if (surfaceObject) {
                    const surfaceList = Object.keys(surfaceObject).map(key => ({
                        ...surfaceObject[key],
                        uid: key,
                    }));

                    setIsLoading(false);
                    setReserves(surfaceList);
                } else {
                    setIsLoading(false);
                    setReserves(reserves);
                }
            });
    };

    return (
        <AuthUserContext.Consumer>
            {authUser => (
                <div>
                    <div>{isLoading && <CircularProgress size={26} />}</div>
                    <div className={classes.error}>
                        {error != null && error}
                    </div>
                    {reserves ? (
                        <ReservationList
                           items = {items}
                            reservations={reserves}
                            profiles={profiles}
                            locations={locations}
                            surfaces={surfaces}
                            users={users}
                            authUser={authUser}
                            firebase={props.firebase}
                            classes={classes}
                        />
                    ) : (
                        <div> There are no profiles yet </div>
                    )}
                </div>
            )}
        </AuthUserContext.Consumer>
    );
}

const ReservationList = ({
    items,
    reservations,
    profiles,
    locations,
    surfaces,
    users,
    authUser,
    firebase,
    classes
}) => {
    let reservationList = [];

    // if (!reservations.length) {
    //     return reservationList;
    // }

    reservations
        .sort((a, b) => b.createdAt - a.createdAt)
        .forEach(reservation => {
            const profile = profiles.find(p => p.uid === reservation.profile);
            const location = locations.find(
                l => l.uid === reservation.location,
            );
            const surface = surfaces.find(s => s.uid === reservation.surface);
            const user = users.find(s => s.uid === reservation.reservedBy);

            if (reservation.approved === 0) {
                reservationList.push({
                    uid: reservation.uid,
                    itemId: reservation.itemId,
                    profileName: profile ? profile.name : "",
                    comment: reservation.comment,
                    location: location ? location.text : "",
                    surface: surface ? surface.text : "",
                    count: reservation.count,
                    length: reservation.length,
                    projectNumber: reservation.projectNumber,
                    reservedBy: user ? user.username : "",
                });
            }
        });


        const approvedMessage = (data) => {
            return  `
                  <!DOCTYPE html>
                  <html>
                    <head></head>
                    <body>
                        <pre>
                          <h4>Hei</h4>
                          <br> Dette e-post bekrefter at ditt ordre  </br>
                          <br> prosjektnummer: ${data.projectNumber} </br>
                          <br> profile: ${data.profileName} </br>
                                <br> lengde: ${data.length} i mm,
                                <br> antall: ${data.count}

                          <br> har blitt godkjent. </br>
                        </pre>
                    </body>
                  </html>
            `;
        }
        const disApprovedMessage = (data) => {
            return  `
            <!DOCTYPE html>
            <html>
              <head></head>
              <body>
                  <pre>
                    <h4>Hei</h4>
                    <br> Ta kontakt med Sven Erik ang ditt ordre på </br>
                    <br> prosjektnummer: ${data.projectNumber} </br>
                    <br> profil: ${data.profileName} </br>
                          <br> lengde: ${data.length} i mm,
                          <br> antall: ${data.count}
                  </pre>
              </body>
            </html>
          `;
        }

    const onClickDisApprove = rowData => {
        new Promise(resolve => {
            if (rowData) {
                firebase
                    .reserve(rowData.uid)
                    .set({ ...rowData, approved: DISAPPROVED });

                        const emailBody = disApprovedMessage(rowData);
                        sendEmail(rowData, `Ta kontakt med Sven Erik`, emailBody );

                        resolve();
            }

            new Promise(resolve => {
                const item = items.filter(f => f.uid === rowData.itemId );

                if (rowData && item.length > 0) {
                    firebase
                        .item(rowData.itemId)
                        .set({ ...item[0], length : parseInt (item[0].length, 10) + parseInt(rowData.length, 10) });

                        resolve();
                }
            });
        });
    };


    const onClickApprove = rowData => {
        const oldReserve = reservations.find(r => r.uid === rowData.uid);
        if (rowData && oldReserve) {
            firebase
                .reserve(rowData.uid)
                .set({ ...oldReserve, approved: APPROVED })
                .then(a => {
                    firebase
                        .reserve(rowData.uid)
                        .once("value")
                        .then(snap => {
                            console.log(rowData);
                            const emailBody = approvedMessage(rowData);

                            sendEmail(rowData, "Ditt ordre er godkjent.", emailBody);
                });
            });
        }
    };

    const columns = [
        {
            field: "url",
            title: "Godkjent",
            render: (rowData, index) => (
                <div style={{ display: "flex" }}>
                    <IconButton
                        style={{ color: "#98C033" }}
                        aria-label="approve"
                        onClick={() => onClickApprove(rowData, index)}
                    >
                        <ThumbUpIcon />
                    </IconButton>
                    <IconButton
                        style={{ color: "lightred" }}
                        aria-label="disapprove"
                        onClick={() => onClickDisApprove(rowData)}
                    >
                        <CancelIcon />
                    </IconButton>
                </div>
            ),
        },
        { title: "Uid", field: "uid", hidden: true },
        { title: "Profil", field: "profileName", editable: "never" },
        { title: "Lengde i mm", field: "length" },
        { title: "Antall", field: "count" },
        { title: "Lokasjon", field: "location", editable: "never" },
        { title: "Overflate", field: "surface", editable: "never" },
        { title: "ProjektNr", field: "projectNumber", editable: "never" },
        { title: "Reservert", field: "reservedBy", editable: "never" },
        { title: "Kommentar", field: "comment" },
    ];

    return (
        <div className={classes.materialTable}>
            <MaterialTable
                icons={tableIcons}
                title=""
                columns={columns}
                data={reservationList}
                localization={{
                    pagination: {
                        labelDisplayedRows: "{from}-{to} av {count}",
                        labelRowsSelect: "rad",
                    },
                    header: {
                        actions: "Handlinger",
                    },
                    body: {
                        emptyDataSourceMessage: "Ingen Reservasjon ennå",
                        editRow: {
                            saveTooltip: "Lagre",
                            cancelTooltip: "Avbryt",
                            deleteText:
                                "Er du sikker på at du vil slette denne reservasjon?",
                        },
                        deleteTooltip: "Slett",
                        editTooltip: "Rediger",
                    },
                    toolbar: {
                        searchPlaceholder: "Søk",
                        searchTooltip: "Søk",
                    },
                }}
                // editable={{
                //     onRowUpdate: (newData, oldData) =>
                //         new Promise(resolve => {
                //             if (oldData) {
                //                 firebase
                //                     .reserve(newData.uid)
                //                     .set({ ...newData });
                //                 resolve();
                //             }
                //         }),
                //     onRowDelete: oldData =>
                //         new Promise(resolve => {
                //             firebase.reserve(oldData.uid).remove();
                //             resolve();
                //         }),
                // }}
            />
        </div>
    );
};

const Reservations = withFirebase(ReservationBase);
const condition = authUser =>
    authUser &&
    authUser.roles &&
    (authUser.roles[ADMIN] === ADMIN || authUser.roles[WS] === WS);

export default compose(
    withAuthorization(condition),
    withEmailVerification,
    withFirebase,
)(Reservation);
